<template>
    <CRow class="mt-3">
        <CCol col="12" sm="12" md="10" lg="7" xl="6" class="mx-auto">
            <FinancialInformationForm class="p-2 b-a-2 bg-white" :user="user" :submit="submit">
                <template #submitBtn="{invalid}">
                    <CCol col="12" class="b-t-1 pt-2 mt-3">
                        <CButton :disabled="invalid" type="submit"  color="primary" class="px-4 float-right">{{ $t('btn.next_step') }}</CButton>
                        <CButton type="button" @click="prev" color="outline-primary" class="px-4 ml-auto float-left">{{ $t('btn.prev_step') }}</CButton>
                    </CCol>
                </template>
            </FinancialInformationForm>
        </CCol>
    </CRow>
</template>

<script>
import { mapActions } from 'vuex'
import { UserSetupStatus } from '@/constants'
import FinancialInformationForm from '@/views/users/components/FinancialInformationForm'

export default {
    name: 'FinancialInformation',

    components: {
        FinancialInformationForm
    },

    data() {
        return {
            userLocal: {}
        }
    },

    computed: {
        user() {
            if (this.$currentUser().id && this.$currentUser().sheba_number) {
                return Object.assign({}, this.$currentUser(), {
                    sheba_number: this.$currentUser().sheba_number.replace(/[ir]/gmi, '')
                })
            }
            return this.$currentUser()
        }
    },

    methods: {
        ...mapActions({
            updateCurrentUserFinancial: 'user/updateCurrentUserFinancial',
            setMsg: 'messageComponent/setMsg',
            resetMsg: 'messageComponent/resetMsg',
            setShowLoading: 'loadingComponent/setShowLoading',
            changeCurrentUserSetupStatus: 'user/changeCurrentUserSetupStatus',
        }),
        clearMsg() {
            this.resetMsg()
        },
        submit() {
            this.setShowLoading()
            this.resetMsg()

            const data = {
                card_number: this.user.card_number,
                sheba_number: this.user.sheba_number ? 'IR' + this.user.sheba_number : '',
                account_owner_name: this.user.account_owner_name,
                account_number: this.user.account_number,
                birth_certificate: this.user.birth_certificate,
                bank_name: this.user.bank_name,
                national_card: this.user.national_card
            }

            this.updateCurrentUserFinancial(data).then(() => {
                this.changeCurrentUserSetupStatus(UserSetupStatus.MEDIA).then(() => {
                    this.setShowLoading(false)
                })
            })
            .catch(result => {
                this.setShowLoading(false)
                this.setMsg({
                    content: this.$t('tags.' + result.tag),
                    type: 'danger'
                })
            })
        },
        prev() {
            this.setShowLoading()

            this.changeCurrentUserSetupStatus(UserSetupStatus.PERSONAL_INFO).then(() => {
                this.setShowLoading(false)
            })
        }
    }
}
</script>